import React from 'react'
import { connect } from 'dva'
import { templateConfig, reduxTemplateCofig } from './config'
import { framework_tool, component_tool, utils_tool } from '../../../tool'
let { WizContainer, WizReduxTemplate } = framework_tool
let { WizBrowserExport } = component_tool
let {Session} = utils_tool

class SiteEquipment extends WizContainer {
  componentName = 'siteEquipment'

  constructor(props) {
    super(props)
    this.state = {
      record: {}
    }
  
    const {history} = props
    let trainSiteInfo = {}
    if (history.location && history.location.pathname === '/site/trainSite/siteEquipment') {
      if (history.location && history.location.record) {
        trainSiteInfo = history.location.record
        Session.set('trainSiteInfo', trainSiteInfo)
      } else {
        trainSiteInfo = Session.get('trainSiteInfo') || {}
      }
    }
    this.trainSiteInfo = trainSiteInfo;
  }

  _onChange = {
    record: this._recordOnChange.bind(this)
  }

  _recordOnChange(nextProps, nextState) {
    this.setState({ record: nextState.record || {} })
    return true
  }

  _columns = () => {
    let defaultProps = {
      cellStyle: {
        textAlign: 'center',
      },
      style: {
        alignment: { vertical: 'bottom', horizontal: 'left' },
      }
    }
    return [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '设备编号',
        field: 'code',
        width: 20,
        ...defaultProps
      },
      {
        headerName: '设备ID',
        field: 'deviceId',
        width: 20,
        ...defaultProps
      },
      {
        headerName: '设备类型',
        field: 'typeMessage',
        width: 15,
        ...defaultProps
      },
      {
        headerName: '设备型号',
        field: 'deviceModel',
        width: 15,
        ...defaultProps
      },
      {
        headerName: '设备状态',
        field: 'statusMessage',
        width: 15,
        ...defaultProps
      },
      {
        headerName: '关联场地名称',
        field: 'siteName',
        width: 20,
        ...defaultProps
      },
      {
        headerName: '关联场地编号',
        field: 'siteCode',
        width: 20,
        ...defaultProps
      },
      {
        headerName: '添加时间',
        field: 'createTime',
        width: 20,
        ...defaultProps
      }
    ]
  }

  _export = (nextProps, nextState, key) => {
    let o = nextProps[key]
    if (o.success) {
      let columns = this._columns()
      WizBrowserExport({
        title: '场地设备',
        sheetName: '场地设备',
        columns: columns.filter((_, index) => index),
        rows: o.data,
        filename: '场地设备.xlsx',
      })
      return true
    } else {
      wizNotice.error(o.msg)
      return false
    }
  }
  
  _getPushProps = () => {
    let { location } = this.props;
    let trainSiteInfo = location['record'] ? location['record'] : undefined
    if (!trainSiteInfo) {
      trainSiteInfo = this.trainSiteInfo;
    }
    console.log('trainSiteInfo',trainSiteInfo)
    return trainSiteInfo
  }
  
  _render() {
    let pushProps = this._getPushProps();
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: templateConfig(this),
      apiDataFormat: {
        export: this._export
      },
      siteId: pushProps && pushProps.id
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}
const mapStateToProps = (state, ownProps) => {
  return {}
}



export default connect(mapStateToProps)(SiteEquipment)